import Logo, { StarMark } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "industries", label: "Industries" },
  { id: "contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/8 bg-abyss/60 pt-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10 pb-14 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-sm">
            <Logo />
            <p className="mt-5 text-sm leading-relaxed text-slate-500">
              Rapid-deployment project management, project rescue & assurance,
              and AI implementation — for short-term, long-term and last-minute
              engagements.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-slate-500">
              Navigate
            </p>
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`footer-link-${l.id}`}
                onClick={() => scrollToId(l.id)}
                className="w-fit text-sm text-slate-400 transition-colors hover:text-gold"
              >
                {l.label}
              </button>
            ))}
          </div>

          <div className="max-w-xs">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-slate-500">
              Direct line
            </p>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              All enquiries are routed through the form above — urgent
              briefs are triaged first.
            </p>
            <button
              data-testid="footer-cta-contact"
              onClick={() => scrollToId("contact")}
              className="mt-5 inline-flex items-center gap-2.5 rounded-full bg-gold px-5 py-2.5 font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-obsidian transition-all duration-300 hover:bg-gold-hover hover:shadow-[0_0_32px_rgba(226,185,92,0.45)]"
            >
              <StarMark className="h-3.5 w-3.5" />
              Request a PM
            </button>
          </div>
        </div>
      </div>

      <div className="border-t border-white/8">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600 sm:flex-row sm:px-6 lg:px-8">
          <span>© {new Date().getFullYear()} Astra Consult. All rights reserved.</span>
          <span>Project management & implementation consulting</span>
        </div>
      </div>
    </footer>
  );
}
